import React, { useEffect, useRef, useState } from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
interface ScrollRevealProps extends BoxProps {
  children: React.ReactNode;
  delay?: number;
}

/**
 * Adds a CSS-driven fade + slide when the block enters the viewport.
 * The observer only toggles a class — all motion is handled by the GPU
 * (transform + opacity) in index.css.
 */
export function ScrollReveal({
  children,
  delay = 0,
  ...props
}: ScrollRevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    if (typeof IntersectionObserver === 'undefined' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setIsVisible(true);
      return;
    }
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -40px 0px'
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return <Box ref={ref} className={isVisible ? 'reveal is-visible' : 'reveal'} style={delay ? {
    transitionDelay: `${delay}ms`
  } : undefined} {...props} data-id="element-15" data-mp="xscrn8m8wfe">
      {children}
    </Box>;
}